/* FIXCOMART HOT DEALS - HARGA CORET V3 */
(() => {
  "use strict";

  const cache = new Map();
  const watched = new WeakSet();
  const processing = new WeakSet();

  const formatPrice = cents =>
    "Rp " + Math.round(cents / 100).toLocaleString("id-ID");

  // FIXCOMART - LABEL DISKON DINAMIS
  function addDiscountBadge(card, oldPrice, sellingPrice) {
    const discount = Math.round(
      ((oldPrice - sellingPrice) / oldPrice) * 100
    );

    let badge = card.querySelector(".fixco-discount-badge");

    if (discount <= 0 || !Number.isFinite(discount)) {
      badge?.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement("span");
      badge.className = "fixco-discount-badge";

      const imageWrap = card.querySelector(".hd-bold-img-wrap");

      if (!imageWrap) return;

      imageWrap.style.position = "relative";
      imageWrap.appendChild(badge);
    }

    badge.textContent = `-${discount}%`;

    badge.style.cssText = `
      position:absolute!important;
      bottom:8px!important;
      right:8px!important;
      z-index:5!important;
      display:inline-flex!important;
      align-items:center!important;
      justify-content:center!important;
      padding:5px 9px!important;
      border-radius:6px!important;
      background:#FFDE35!important;
      color:#EC2227!important;
      font:900 13px/1 Arial,sans-serif!important;
      white-space:nowrap!important;
      text-decoration:none!important;
      box-shadow:0 2px 5px #00000018!important;
      pointer-events:none!important;
    `;
  }

  async function getProduct(handle) {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(
          `/products/${encodeURIComponent(handle)}.js`,
          { credentials: "same-origin" }
        )
          .then(res => {
            if (!res.ok) throw new Error("Product fetch failed");
            return res.json();
          })
          .catch(err => {
            cache.delete(handle);
            console.warn("[Fixco Price]", err);
            return null;
          })
      );
    }

    return cache.get(handle);
  }

  async function addComparePrice(card) {
    if (processing.has(card)) return;

    const prices = card.querySelector(".hd-bold-prices");
    const current = card.querySelector(".hd-bold-now");

    if (!prices || !current) return;

    processing.add(card);

    try {
      const url = new URL(card.href);
      const handle = url.pathname.match(/\/products\/([^/]+)/)?.[1];
      const variantId = url.searchParams.get("variant");

      if (!handle || !variantId) return;

      const product = await getProduct(handle);
      if (!product || !card.isConnected) return;

      const variant = product.variants?.find(
        v => String(v.id) === String(variantId)
      );

      if (!variant) return;

      const oldPrice = Number(variant.compare_at_price);
      const displayedPrice = Number(
        current.textContent.replace(/[^0-9]/g, "")
      );

      const existing = prices.querySelector(".fixco-price-was");

      if (
        !Number.isFinite(oldPrice) ||
        oldPrice <= displayedPrice * 100
      ) {
        existing?.remove();
        card.querySelector(".fixco-discount-badge")?.remove();
        return;
      }

      const label = existing || document.createElement("span");

      label.className = "fixco-price-was";
      label.textContent = formatPrice(oldPrice);

      label.style.cssText = `
        display:block!important;
        color:#999!important;
        font-size:12px!important;
        font-weight:400!important;
        text-decoration:line-through!important;
        line-height:1.3!important;
        margin-bottom:3px!important;
      `;

      if (!existing) {
        prices.insertBefore(label, current);
      }

      // Tambahkan badge diskon berdasarkan harga masing-masing produk
      addDiscountBadge(card, oldPrice, displayedPrice * 100);

    } catch (error) {
      console.warn("[Fixco Price]", error);
    } finally {
      processing.delete(card);
    }
  }

  function scan(root) {
    root.querySelectorAll(".hd-bold-card").forEach(card => {
      if (
        !card.querySelector(".fixco-price-was") ||
        !card.querySelector(".fixco-discount-badge")
      ) {
        addComparePrice(card);
      }
    });
  }

  function watchRoot(root) {
    if (!root || watched.has(root)) return;

    watched.add(root);
    scan(root);

    const observer = new MutationObserver(records => {
      const needsScan = records.some(record =>
        [...record.addedNodes].some(node =>
          node.nodeType === 1 &&
          !node.classList?.contains("fixco-price-was") &&
          !node.classList?.contains("fixco-discount-badge")
        )
      );

      if (needsScan) scan(root);
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    document
      .querySelectorAll('[data-hd-mount="carousel"]')
      .forEach(mount => {
        if (mount.shadowRoot) {
          watchRoot(mount.shadowRoot);
        } else {
          watchRoot(mount);
        }
      });
  }

  const pageObserver = new MutationObserver(init);

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, {
      once: true
    });
  } else {
    init();
  }

  console.log("[Fixco Price V3] Loaded");
})();